import React, { Component } from 'react'
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column'
import {Button} from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import classNames from 'classnames';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { CiteService } from '../../service/CiteService';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactLoading from 'react-loading';
import { CategorieChambreService } from '../../service/CategorieChambreService';



export class PrixChambre extends Component {
    emptyPrixChambre = {
        idCategorieChambre : 0,
        idCite : 0,
        libelleCategorieChambre : "",
        montantChambre : ""
    };
    constructor() {
        super();
        this.state = {

            listeCategorieChambre : [],
            listeCite : [],
            idCiteFiltre : null,
            prixChambreDialog: false,
            prixChambre: this.emptyPrixChambre,
            submitted: false,
            loading : false,
            globalFilter: null
        }

        this.categorieChambreService = new CategorieChambreService();
        this.citeService = new CiteService();

        this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
        this.montantBodyTemplate = this.montantBodyTemplate.bind(this);

        this.hideDialog = this.hideDialog.bind(this);
        this.savePrixChambre = this.savePrixChambre.bind(this);
        this.editPrixChambre = this.editPrixChambre.bind(this);
        this.onMontantChambreChange = this.onMontantChambreChange.bind(this);
        this.loadPrixChambre = this.loadPrixChambre.bind(this);
    }
    componentDidMount() {
        this.loadPrixChambre();

        this.citeService.getAll().then(data => {
            this.setState({listeCite: data})
        })
        .catch(error => {this.notify2() ; console.log(error)})
    }

    loadPrixChambre() {
        this.setState({loading : true})
        this.categorieChambreService.getAll().then(data =>
            this.setState({listeCategorieChambre: data, loading : false})
            )
            .catch(error => {
                this.notify2()
                console.log(error)
                this.setState({loading : false})
            })
    }
    hideDialog() {
        this.setState({
            submitted: false,
            prixChambreDialog: false
        });
    }
    savePrixChambre() {
        let state = { submitted: true };

        if (this.state.prixChambre.montantChambre) {

            const newCategorieChambre = {
                idCategorieChambre : parseInt(this.state.prixChambre.idCategorieChambre) ,
                idCite : parseInt(this.state.prixChambre.idCite) ,
                libelleCategorieChambre : this.state.prixChambre.libelleCategorieChambre,
                montantChambre : parseInt(this.state.prixChambre.montantChambre) ,
            }
            console.log(newCategorieChambre)
            this.categorieChambreService.update(parseInt(this.state.prixChambre.idCategorieChambre), newCategorieChambre)
                            .then(data => {
                                this.notify();
                                this.loadPrixChambre();
                            })
                            .catch(error => {
                                this.notify2()
                                console.log(error);
                            })

            state = {
                ...state,
                prixChambreDialog: false,
                prixChambre: this.emptyPrixChambre
            };
        }

        this.setState(state);
    }
    editPrixChambre(rowData) {
        // la cité et la catégorie ne sont pas modifiables ici : seul le prix l'est
        let idCite = rowData.idCite;
        if (!idCite) {
            const cite = this.state.listeCite.find(c => c.nomCite === rowData.nomCite);
            idCite = cite ? cite.idCite : 0;
        }
        this.setState({
            prixChambre : {
                idCategorieChambre : rowData.idCategorieChambre,
                idCite : idCite,
                nomCite : rowData.nomCite,
                libelleCategorieChambre : rowData.libelleCategorieChambre,
                montantChambre : rowData.montantChambre
            },
            submitted: false,
            prixChambreDialog: true
        });
    }

    onMontantChambreChange(e, montantChambre) {
        const val = (e.target && e.target.value) || '';
        // on n'accepte que des chiffres pour un montant
        if (val && !/^\d+$/.test(val)) {
            return;
        }
        let prixChambre = this.state.prixChambre;
        prixChambre[`${montantChambre}`] = val;

        this.setState({ prixChambre });
    }
    getListeFiltree() {
        if (!this.state.idCiteFiltre) {
            return this.state.listeCategorieChambre;
        }
        const cite = this.state.listeCite.find(c => c.idCite === this.state.idCiteFiltre);
        return this.state.listeCategorieChambre.filter(categorie =>
            categorie.idCite === this.state.idCiteFiltre || (cite && categorie.nomCite === cite.nomCite)
        );
    }
    montantBodyTemplate(rowData) {
        if (rowData.montantChambre === null || rowData.montantChambre === undefined || rowData.montantChambre === '') {
            return <span style={{color : "red"}}>Non défini</span>;
        }
        return <span>{Number(rowData.montantChambre).toLocaleString('fr-FR')} FCFA</span>;
    }
    actionBodyTemplate(rowData) {
        return (
            <React.Fragment>
                <Button type="button" icon="pi pi-pencil" className="p-button-warning" onClick={() => this.editPrixChambre(rowData)} style={{marginRight: '.5em'}}/>
            </React.Fragment>
        );
    }
    notify = () => toast.success('Opération réuçit!', {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    notify2 = () => toast.error("Echec de l'opération !", {
            position: "top-right",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        })
    loadingSpinner = ( type, color) => (
        <ReactLoading type={type} color={color} height={200} width={50} />
    )
    render() {
        let actionHeader = <Button type="button" icon="pi pi-cog"/>;
        const header = (
            <div className="table-header p-col-2">
                <span className="p-input-icon-left">
                    <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Recherche globale..." />
                </span>
            </div>
        );
        const prixChambreDialogFooter = (
            <React.Fragment>
                <Button label="Quitter" icon="pi pi-times" className="p-button-text" onClick={this.hideDialog} />
                <Button label="Enregistrer" icon="pi pi-check" className="p-button-text" onClick={this.savePrixChambre} />
            </React.Fragment>
        );

        return (
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="p-grid">
                        <div className="p-col-4">
                            <Dropdown optionLabel="nomCite" optionValue="idCite" value={this.state.idCiteFiltre} options={this.state.listeCite}
                                      onChange={(e) => this.setState({idCiteFiltre : e.value})} showClear={true} placeholder="Filtrer par cité"/>
                        </div>
                        <div className="p-col-2">
                            <Button label="Rafraichir" icon="pi pi-refresh" className="" onClick={this.loadPrixChambre} />
                        </div>
                    </div>

                    <div className="card card-w-title datatable-demo">
                    <ToastContainer
                        position="top-right"
                        autoClose={2000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                    <ToastContainer />
                        {header}
                        {this.state.loading ?
                        <div className="p-grid">
                            <div className="p-col-6" ></div>
                            <div className="p-col-6" >
                                {this.loadingSpinner("spin","black")}
                            </div>
                        </div>
                        :
                        <DataTable  ref={(el) => this.dt = el} value={this.getListeFiltree()} selectionMode="single" header="Prix des chambres par cité et catégorie" paginator={true} rows={10}
                              globalFilter={this.state.globalFilter} filterMatchMode="contains" responsive={true} selection={this.state.dataTableSelection1} onSelectionChange={event => this.setState({dataTableSelection1: event.value})}>
                            <Column field="nomCite" header="Cité" filterMatchMode="contains" sortable={true} filter={true} filterPlaceholder="rechercher cité"/>
                            <Column field="libelleCategorieChambre" header="Catégorie chambre" filterMatchMode="contains" sortable={true} filter={true} filterPlaceholder="rechercher catégorie chambre"/>
                            <Column field="montantChambre" header="Prix" body={this.montantBodyTemplate} filterMatchMode="contains" sortable={true} filter={true} filterPlaceholder="rechercher prix"/>
                            <Column header={actionHeader} body={this.actionBodyTemplate} style={{textAlign:'center', width: '8em'}}/>
                        </DataTable>
                        }
                    </div>
                </div>

                <Dialog visible={this.state.prixChambreDialog} style={{ width: '450px' }} header="Prix de la chambre" modal className="p-fluid" footer={prixChambreDialogFooter} onHide={this.hideDialog}>
                    <div className="p-field">
                        <label htmlFor="nomCite">Cité</label>
                        <InputText id="nomCite" value={this.state.prixChambre.nomCite || ''} disabled />
                    </div>
                    <div className="p-field">
                        <label htmlFor="libelleCategorieChambre">Catégorie chambre</label>
                        <InputText id="libelleCategorieChambre" value={this.state.prixChambre.libelleCategorieChambre || ''} disabled />
                    </div>
                    <div className="p-field">
                        <label htmlFor="montantChambre">Prix (FCFA)</label>
                        <InputText id="montantChambre" value={this.state.prixChambre.montantChambre} keyfilter="pint" onChange={(e) => this.onMontantChambreChange(e, 'montantChambre')} required autoFocus className={classNames({ 'p-invalid': this.state.submitted && !this.state.prixChambre.montantChambre })} />
                        {this.state.submitted && !this.state.prixChambre.montantChambre && <small className="p-invalid" style={{color : "red"}}>Ce champs est obligatoire.</small>}
                    </div>
                </Dialog>
            </div>
        )
    }
}

export default PrixChambre
